import { useState, useEffect } from 'react';
import { getTestimonials } from '../services/api';
import TestimonialCard from '../components/TestimonialCard';
import { clientTestimonials } from '../content/companyContent';
import './Testimonials.css';

function Testimonials() {
  const [testimonials, setTestimonials] = useState(clientTestimonials);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await getTestimonials();
      const data = response.data.results || response.data;
      setTestimonials(data.length ? data : clientTestimonials);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      setTestimonials(clientTestimonials);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="testimonials-page">
      <div className="testimonials-hero">
        <h1>What Our Clients Say</h1>
        <p>Real experiences and feedback from our valued customers</p>
      </div>

      <div className="testimonials-container">
        {loading ? (
          <p className="loading">Loading testimonials...</p>
        ) : (
          <div className="testimonials-grid">
            {testimonials.map(testimonial => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Testimonials;
